export default "__VITE_ASSET__kekjwhzU__"